import lang from '../../lib/language';

export { EarningsSymbolFilterEnum } from '../../lib/store/fundamental/types';

export const EARNINGS_CONTENT_PER_PAGE_LENGTH = 15;
export const EARNINGS_CONTENT_UNLIMIT_LENGTH = Number.MAX_VALUE;

/**
 * Defined here because the two apps keep their own copy under different
 * filenames (`WatchList.constants` and `WatchList.constans`).
 */
export const EARNINGS_TABLE_HEADERS = [
  lang.headerAccountBreakdownSymbolName(),
  lang.commonDate(),
  lang.headerEarningsCalendarEarningsCallTime(),
  lang.headerEarningsCalendarEarningsEpsSurpriseEst(),
];
